import { memo } from "react"
import { LaunchRounded } from "@mui/icons-material"
import { Button } from "@mui/material"
import type { SyncFinishedNotificationDto } from "@oboku/shared"
import { useNavigate } from "react-router"
import { ROUTES } from "../../../navigation/routes"
import { useMarkNotificationAsSeen } from "../useMarkNotificationAsSeen"
import { NotificationCardBase } from "./NotificationCardBase"

export const SyncFinishedNotificationCard = memo(
  function SyncFinishedNotificationCard({
    notification,
  }: {
    notification: SyncFinishedNotificationDto
  }) {
    const navigate = useNavigate()
    const markAsSeen = useMarkNotificationAsSeen()

    const openReports = () => {
      if (!notification.seenAt) {
        markAsSeen.mutate({ id: notification.id })
      }

      navigate(ROUTES.SYNC_REPORTS)
    }

    return (
      <NotificationCardBase
        notification={notification}
        cta={
          <Button
            size="small"
            variant="contained"
            startIcon={<LaunchRounded />}
            onClick={openReports}
          >
            Open reports
          </Button>
        }
      />
    )
  },
)
